import { ScoresColumn } from "./scoresTable.types";
import { defaultLegendColumn } from "./legend-columns/defaultLegendColumn";
import { groupedNormsLegendColumn } from "./legend-columns/groupedNormsLegendColumn";
import { meanColumn } from "./legend-columns/meanColumn";
import { EXTRA_MEAN_COLUMN_INSTRUMENT_IDS, GROUPED_NORMS_INSTRUMENT_IDS } from "./scoresTableConstants";

export const resolveTrailingColumns = (instrumentId?: string): Array<ScoresColumn> => {
	if (instrumentId && EXTRA_MEAN_COLUMN_INSTRUMENT_IDS.includes(instrumentId)) return [meanColumn, defaultLegendColumn];
	if (instrumentId && GROUPED_NORMS_INSTRUMENT_IDS.includes(instrumentId)) return [groupedNormsLegendColumn];
	return [defaultLegendColumn];
};
